import * as React from 'react';
import * as styles from '../ProgressBar.css';
import { observer } from 'mobx-react';
import { ContentOrganizerStore } from '../../stores';
import { IAIcon } from '../../../icon/Icon';

export interface IProgressBarItemProps {
  title: string;
  selected: boolean;
  step: number;
  contentOrganizerStore?: ContentOrganizerStore;
  onClick?: (item?: any) => void;
  onSelectedStep: (step) => void;
}

export interface IProgressBarItemState {
  selected: boolean;
}

@observer
export class ProgressBarItem extends React.Component<IProgressBarItemProps, IProgressBarItemState>{

  constructor(props: IProgressBarItemProps) {
    super(props);
    this.state = {
      selected: props.selected
    };
  }

  public componentWillReceiveProps(props: IProgressBarItemProps) {
    if (props !== this.props) {
      this.setState({ selected: props.selected });
    }
  }

  render() {
    return (
      <div>
        {this.props.step > 0 &&
          <div 
            className={ styles.progressBarItemVerticalLine}
            style={this.props.contentOrganizerStore.selectedStep >= this.props.step ? {
              borderColor:"rgb(0, 128, 0)"
            }: undefined}></div>
        }
        <div
          className={styles.progressBarItem}
          style={this.props.step > 0 ? {
            marginTop:0
          } : undefined}
          onClick={() => {
          if (this.props.step !== 0) {
            if(!this.props.contentOrganizerStore.checkData()) {
              this.props.contentOrganizerStore.setStep(this.props.step)
              this.props.onSelectedStep(this.props.step);
            }
          } else {
            this.props.contentOrganizerStore.setStep(this.props.step)
            this.props.onSelectedStep(this.props.step);
          }
        }
        }
      >
          {this.props.contentOrganizerStore.selectedStep == this.props.step &&
            <div className={[styles.progressBarItemIcon, styles.progressBarItemIconSelected].join(" ")}>
              {this.props.step+1}
            </div>
          }
          {this.props.contentOrganizerStore.selectedStep < this.props.step &&
            <div className={[styles.progressBarItemIcon, styles.progressBarItemIconUnselected].join(" ")}>
              {this.props.step+1}
            </div>
          }
          {this.props.contentOrganizerStore.selectedStep > this.props.step &&
            <div className={styles.progressBarItemIconPast}>
              <IAIcon 
                title="Checkmark"
                size={15}
                color={"white"}
              />
            </div>
          }
        <div className={this.props.contentOrganizerStore.selectedStep >= this.props.step ? styles.progressBarItemTitleFilled : styles.progressBarItemTitleUnfilled}>
          {this.props.title}
        </div>
      </div>
      </div>
    );
  } 
}